import { render, staticRenderFns } from "./administratorsModal.vue?vue&type=template&id=28aead90&"
import script from "./administratorsModal.vue?vue&type=script&lang=js&"
export * from "./administratorsModal.vue?vue&type=script&lang=js&"
import style0 from "./administratorsModal.vue?vue&type=style&index=0&id=28aead90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports